import GenreForm from "./forms/GenreForm";
import ManufacturerForm from "./forms/ManufacturerForm";
import ProductCategoryForm from "./forms/ProductCategoryForm";
import GenreList from "./lists/GenreList";
import ManufacturerList from "./lists/ManufacturerList";
import ProductCategoryList from "./lists/ProductCategoryList";

const basicConfig = [
  {
    group: "People",
    items: [
      {
        path: "genres",
        name: "Genres",
        List: GenreList,
        Form: GenreForm,
      },
    ],
  },
  {
    group: "E-commerce",
    items: [
      {
        path: "product-category",
        name: "Categories",
        List: ProductCategoryList,
        Form: ProductCategoryForm,
      },
      {
        path: "manufacturer",
        name: "Manufacturers",
        List: ManufacturerList,
        Form: ManufacturerForm,
      },
    ],
  },
];

export default basicConfig;
